/* IotOsPlanDetailsViewRenderer.js */

"use strict";
const _ = require("lodash");
const Registrations = require("../../../../../RegistrationNamespaces");

const Forms = require("@gluenetworks/forms");
const FormsComponent = Forms.ui.component;
const EntityGrid = require("@gluenetworks/entity_grid_gl").Grid;
const readOnlyFieldIds = [
    "status",
    "imageAssociations",
    "deviceCount",
    "lastWorkId",
    "osmOptions",
    "ignoreLinkIds",
    "deviceUpgradeStatuses",
];
const RunNowComponent = require("./veils/RunNowComponent");
const ScheduleComponent = require("./veils/ScheduleComponent");
const OsmOptionsComponent = require("./veils/OsmOptionsComponent");
const childViewComponent = require("../../../../widgets/childview/ChildViewRenderer");
const manageDeviceComponent = require("./subviews/manage_device/ManageDeviceViewComponent");
const validateViewComponent = require("./subviews/validate/ValidateViewComponent");
const StatusFlow = require("./StatusFlowComponent");
const disabledStatus = ["RUNNING", "COMPLETE", "CANCELED", "ERROR", "VALIDATING", "SCHEDULED"];
const VIEW_ACTION_IDS = [
    "SavePlanDetails",
    "CancelPlanDetails",
    "ManageDevices",
    "ValidatePlan",
    "ValidationLogs",
    "OsmOptions",
    "DownloadUpgradeZip",
    "ImportUpgradeResults",
    "AddImages",
];
const manageImagesComponent = require("./subviews/image_details/ImageDetailsComponent");
class OsPlanDetailsViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("os-plan-details-view-gl");
        this._rootElem.component = this.model;
        this._logger = this.model.logger;
        this._isDirty = false;
        this._formsComponent = new FormsComponent();
        this._childViewRenderer = undefined;
        this.flowGraphic = undefined;
        this._previousStatus = undefined;
        this._flowGraphicContainer = document.createElement("div");
        this._flowGraphicContainer.className = "status-flow-graphic";

        this._gridSection = document.createElement("div");
        this._gridSection.classList.add("grid-section");
        this._groupingValuesFeed = [];
        this._emptyMessage = document.createElement("game-editor-message-gl");
        this._emptyMessage.classList.add("actionable");
        this._iconContainer = document.createElement("span");
        this._iconContainer.classList.add("icon-container");
        this._icon = document.createElement("game-editor-actionable-icon-gl");
        this._icon.dataset.icon = "configdrift.add_device";
        this._iconContainer.classList.add("has-icon");
        this._iconContainer.appendChild(this._icon);
        this._messageContainer = document.createElement("span");
        this._messageContainer.classList.add("message-container");
        this._messageContainer.innerHTML = "Add a Device";
        this._emptyMessage.appendChild(this._iconContainer);
        this._emptyMessage.appendChild(this._messageContainer);
        this._emptyDeviceContainer = document.createElement("game-editor-message-gl");
        this._emptyDeviceContainer.classList.add("empty-support-msg");
        this._emptyDeviceContainer.innerHTML = "No Supported Devices Available";
        this._validateView = undefined;
        this._runNowComponent = undefined;
        this._renderingForm = false;
        this._actionSelection = undefined;
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._model.on("Dirty", (this._onDirty = this._onDirty.bind(this)));
        this._model.on(
            "PlanPropertiesChanged",
            (this._onPlanPropertiesChanged = _.debounce(
                this._onPlanPropertiesChanged.bind(this),
                500,
                false
            ))
        );
        this._model.on(
            "RefreshPlanDetails",
            (this._onRefreshPlanDetails = this._onRefreshPlanDetails.bind(this))
        );
        this._formsComponent.on(
            "PendingPatchesChanged",
            (this._onFormsPendingPatchesChanged = _.debounce(
                this._onFormsPendingPatchesChanged.bind(this),
                500,
                false
            ))
        );
        this._model._pagingRelatedFeed.on(
            "RefreshView",
            (this._onFeedRefreshView = this._onFeedRefreshView.bind(this))
        );
        this._model._pagingDeviceFeed.on(
            "RefreshView",
            (this._onFeedDeviceRefreshView = this._onFeedDeviceRefreshView.bind(this))
        );
        this._iconContainer.addEventListener(
            "click",
            (this._onAddDevices = _.debounce(_.bind(this._onAddDevices, this), 3000, {
                maxWait: 3000,
                leading: true,
                trailing: false,
            }))
        );
        this._messageContainer.addEventListener(
            "click",
            (this._onAddDevices = _.debounce(_.bind(this._onAddDevices, this), 3000, {
                maxWait: 3000,
                leading: true,
                trailing: false,
            }))
        );
    }

    _registerGridListeners() {
        if (this._planResultsGrid) {
            this._planResultsGrid.on(
                "UserSelectedRows",
                (this._onGridUserSelectedRows = this._onGridUserSelectedRows.bind(this))
            );
            this._planResultsGrid.on(
                "UserSorted",
                (this._onGridUserSorted = this._onGridUserSorted.bind(this))
            );
        }
    }

    _unregisterGridListeners() {
        if (this._planResultsGrid && this._onGridUserSelectedRows) {
            this._planResultsGrid.removeListener("UserSelectedRows", this._onGridUserSelectedRows);
        }
        if (this._planResultsGrid && this._onGridUserSorted) {
            this._planResultsGrid.removeListener("UserSorted", this._onGridUserSorted);
        }
    }

    _unregisterListeners() {
        this._model.removeListener("Dirty", this._onDirty);
        this._model.removeListener("PlanPropertiesChanged", this._onPlanPropertiesChanged);
        this._formsComponent.removeListener(
            "PendingPatchesChanged",
            this._onFormsPendingPatchesChanged
        );
        this._model.removeListener("RefreshPlanDetails", this._onRefreshPlanDetails);
        this._model._pagingRelatedFeed.removeListener("RefreshView", this._onFeedRefreshView);
        this._model._pagingDeviceFeed.removeListener("RefreshView", this._onFeedDeviceRefreshView);
        // if (this._groupingValuesFeed) {
        //     this._groupingValuesFeed.removeListener("ValueDeleted", this._onGroupValuesChanged);
        //     this._groupingValuesFeed.removeListener("ValueAdded", this._onGroupValuesChanged);
        // }
        this._iconContainer.removeEventListener("click", this._onAddDevices);
        this._messageContainer.removeEventListener("click", this._onAddDevices);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        this._unregisterGridListeners();
        this._onFormsPendingPatchesChanged.flush();
        let promArr = [
            this._formsComponent.shutdown(),
            this.flowGraphic.shutdown(),
            this._childViewRenderer && this._childViewRenderer.shutdown(),
            this._planResultsGrid ? this._planResultsGrid.shutdown() : Promise.resolve(),
            this._validateView ? this._validateView.shutdown() : Promise.resolve(),
        ];

        if (this._model._modalUserFeedback.isDisplayed()) {
            promArr.push(this._model._modalUserFeedback.hideDisplayed());
        }

        return Promise.all(promArr).then(
            () => {
                this._gridSection.remove();
                this._gridSection = undefined;
                this._childViewRenderer = undefined;
                this._formsComponent = undefined;
                this._renderingForm = undefined;
                this._isDirty = undefined;
                this._logger = undefined;
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._planResultsGrid = undefined;
                this._groupingValuesFeed = undefined;
                this._iconContainer = undefined;
                this._messageContainer = undefined;
                this._emptyMessage.remove();
                this._emptyMessage = undefined;
                this._validateView = undefined;
                this._runNowComponent = undefined;
                this._emptyDeviceContainer = undefined;
                this.flowGraphic = undefined;
                this._flowGraphicContainer = undefined;
                this._previousStatus = undefined;
                this._actionSelection = undefined;
                Promise.resolve();
            },
            (err) => {
                if (!_.isEmpty(this._rootElem)) {
                    if (this._rootElem.remove) {
                        this._rootElem.remove();
                    }
                    this._rootElem = undefined;
                }
                this._logger.warn({error: err}, "OsPlanDetailsViewRenderer.shutdown() error.");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */

    render() {
        this.rootElement.innerHTML = "";
        // this.rootElement.appendChild(this._flowGraphicContainer);
        this.rootElement.appendChild(this._formsComponent.renderer.rootElement);
        this.rootElement.appendChild(this._gridSection);
        return this.model.whenModelIsReady().then(
            () => {
                this._renderPlanDetails().then(() => {
                    this._renderGrid();
                    this._createActions();
                    this._showViewActions();
                });
                this._registerListeners();
            },
            (err) => err
        );
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE ACTION METHODS            */
    /*******************************************/

    _createActions() {
        this.model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Save",
            name: "SavePlanDetails",
            handler: (this._onPlanDetailsSave = this._onPlanDetailsSave.bind(this)),
        });
        this.model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Cancel",
            name: "CancelPlanDetails",
            handler: (this._onPlanDetailsCancel = this._onPlanDetailsCancel.bind(this)),
        });
        this.model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Manage Devices",
            name: "ManageDevices",
            handler: (this._onManageDevices = _.debounce(this._onManageDevices.bind(this), 300)),
        });

        this.model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Validate Plan",
            name: "ValidatePlan",
            handler: (this._onValidatePlan = this._onValidatePlan.bind(this)),
        });
        this.model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Validation Logs",
            name: "ValidationLogs",
            handler: (this._onViewValidationLogs = this._onViewValidationLogs.bind(this)),
        });

        this.model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Manage Images",
            name: "OsmOptions",
            handler: (this._onOsmOptionsClick = this._onOsmOptionsClick.bind(this)),
        });

        this.model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Download Upgrade ZIP",
            name: "DownloadUpgradeZip",
            handler: () => {
                this._model.gameEditor.runAction(
                    Registrations.IOT_OS_PLAN_EDITOR_ACTIONS_OFFLINE_UPGRADE_DOWNLOAD
                );
            },
        });

        this.model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Import Upgrade Results",
            name: "ImportUpgradeResults",
            handler: () => {
                this._model.gameEditor.runAction(
                    Registrations.IOT_OS_PLAN_EDITOR_ACTIONS_OFFLINE_UPGRADE_UPLOAD
                );
            },
        });

        this.model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Add Images",
            name: "AddImages",
            handler: (this._onAddImages = this._onAddImages.bind(this)),
        });
    }

    _enableDisableOsmOptions() {
        this.model.gameEditor.enableViewAction("OsmOptions");
        // if (this._model._osmOptionEntities && this._model._osmOptionEntities.length > 0) {
        //     this.model.gameEditor.enableViewAction("OsmOptions");
        // } else {
        //     this.model.gameEditor.disableViewAction("OsmOptions");
        // }
    }

    _setAllViewActionsVisible(isVisible) {
        VIEW_ACTION_IDS.forEach((action) => this._setViewActionVisible(action, isVisible));
    }

    _setViewActionVisible(actionName, isVisible) {
        const {gameEditor} = this.model;
        gameEditor[isVisible ? "showViewAction" : "hideViewAction"](actionName);
    }

    _showViewActions() {
        this._setAllViewActionsVisible(true);
        this._showHideValidationLogsAction();
        this._setViewActionVisible("AddImages", this._model.childViewOpen);
        this._enableDisableActionsBasedOnStatus(status, this._model.plan.isDirty());
    }

    _hideViewActions() {
        this._setAllViewActionsVisible(false);
    }

    _showHideValidationLogsAction() {
        let lastWorkId =
            _.get(this.model._plan.getPristineProperties(), "lastWorkId") ||
            this._model._validateWorkId;
        let planStatus = this.model._plan.getStatus();
        if (_.isUndefined(this._model.childViewOpen)) {
            const showLogs = lastWorkId && planStatus !== "DRAFT";
            this._setViewActionVisible("ValidationLogs", showLogs);
            this._setViewActionVisible("ValidatePlan", !showLogs);
        }
    }

    _enableAllActions() {
        this._toggleEnableDisableAllActions(true);
    }

    _disableAllViewActions() {
        this._toggleEnableDisableAllActions(false);
    }

    _toggleEnableDisableAllActions(enable) {
        const {gameEditor} = this.model;
        const method = enable ? "enableViewAction" : "disableViewAction";
        VIEW_ACTION_IDS.forEach((action) => gameEditor[method](action));
    }

    _enableDisableRunNowAction(status) {
        if (status === "RUNNING" || status === "QUEUED") {
            this._disableAllViewActions();
            this._setViewActionText("RunNowPlan", "Running...");
        } else if (status === "VALIDATED" && status !== "SCHEDULED") {
            this.model.gameEditor.enableViewAction("RunNowPlan");
        } else if (status === "VALIDATED" && status === "SCHEDULED") {
            this.model.gameEditor.disableViewAction("RunNowPlan");
        } else if (
            (status === "DRAFT" ||
                status === "VALIDATION_ERROR" ||
                status === "VALIDATION_CANCELED") &&
            this._isDirty === false
        ) {
            this.model.gameEditor.disableViewAction("RunNowPlan");
        }
    }

    _disableViewActions() {
        this.model.gameEditor.disableViewAction("SavePlanDetails");
        this.model.gameEditor.disableViewAction("CancelPlanDetails");
    }

    _enableViewActions() {
        this.model.gameEditor.enableViewAction("SavePlanDetails");
        this.model.gameEditor.enableViewAction("CancelPlanDetails");
    }

    _toggleActions() {
        if (this._model.isDirty()) {
            this._enableViewActions();
        } else {
            this._disableViewActions();
        }
    }

    _hideLeftFooterContainer() {
        let leftSelector = this.model.gameEditorRootElement.querySelector("left-container");
        if (leftSelector) {
            leftSelector.style.display = "none";
        }
    }

    _showLeftFooterContainer() {
        let querySelector = this.model.gameEditorRootElement.querySelector("left-container");
        if (querySelector) {
            querySelector.style.display = "block";
        }
    }

    /*******************************************/
    /* END PRIVATE ACTION METHODS              */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    _renderPlanDetails() {
        return Promise.resolve().then(
            () => {
                let jtype = this._getJtype();
                let pristineValue = this._getPristineValue();
                let updatedPristineValueStatus = this._updatePristineValueStatus(pristineValue);
                this._formsComponent.setTypeInformation(jtype, true);
                this._formsComponent.setPristineValue(updatedPristineValueStatus, true);

                this._renderingForm = true;

                return this._formsComponent.renderer.render().then(() => {
                    this._renderingForm = false;
                    const statusFormEl = this._formsComponent.renderer._rootElem.querySelector(
                        "forms-gl div.rendered_control.graphic"
                    );
                    if (statusFormEl.contains(this._flowGraphicContainer)) {
                        statusFormEl.removeChild(this._flowGraphicContainer);
                    }
                    this._flowGraphicContainer = document.createElement("div");
                    this._flowGraphicContainer.className = "status-flow-graphic";
                    this.flowGraphic = undefined;
                    this.flowGraphic = new StatusFlow();
                    this._flowGraphicContainer.appendChild(this.flowGraphic.renderer.rootElement);
                    statusFormEl.insertBefore(
                        this._flowGraphicContainer,
                        statusFormEl.querySelector("input-text-control")
                    );
                    this._setInitialFlowGraphicStatus(this._model._plan.getStatus());
                });
            },
            (err) => {
                this._logger.warn(
                    {error: err},
                    "OsPlanDetailsViewRenderer._renderPlanDetails() error."
                );
            }
        );
    }

    _renderGrid() {
        this._gridSection.classList.add("grid-section");
        this._gridSection.innerHTML = "";
        let leftContainer = this.model.gameEditorRootElement.querySelector(
            "game-editor-view-actions-gl left-container"
        );
        leftContainer.innerHTML = "";
        this._planResultsGrid = new EntityGrid({
            gridKey: this._model._gridKey,
            columns: this._model.columnConfig,
            pagingFeed: this._model._pagingRelatedFeed,
            selectable: true,
            showHeader: true,
            showLinesNumber: this.model.gameEditorRootElement.querySelector(
                "game-editor-view-actions-gl left-container"
            ),
            modalUserFeedback: this._model._modalUserFeedback,
            useUserDataStorage: false,
        });

        // Register grid event listeners
        this._registerGridListeners();

        this._gridSection.appendChild(this._planResultsGrid.renderer.rootElement);

        if (this._model._pagingRelatedFeed.totalEntities === 0) {
            this._showDefaultMessageDisplay();
        }
    }

    _setViewActionText(buttonValue, buttonText) {
        let buttonControl = _.get(
            this.model.gameEditor._viewContainerElem.nextElementSibling.lastElementChild.querySelectorAll(
                "button-control[value='" + buttonValue + "']"
            ),
            0
        );

        if (buttonControl) {
            buttonControl.innerHTML = buttonText;
        }
    }

    _updatePristineValueStatus(pristineValues) {
        let updatedPristineValues = _.clone(pristineValues);
        let statusKey = pristineValues.status;
        updatedPristineValues.status = _.get(
            this._model._gameEditor._iotOsPlanStatusList,
            statusKey,
            statusKey
        );
        return updatedPristineValues;
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    async _refreshGrid() {
        await this._model._pagingRelatedFeed._planFeedReestablish();
        return this._model._pagingRelatedFeed.whenFeedReady();
    }

    _onFormsPendingPatchesChanged() {
        if (!_.isEmpty(this._model)) {
            let isImageAssociated = this._model._plan.imageAssociations;
            const form = this._formsComponent.getValue();
            if (isImageAssociated && !_.isEmpty(isImageAssociated)) {
                this._model
                    ._clearImageAssociationVeil(form.groupedBy)
                    .then(() => {
                        this._onFormChangeValue();
                    })
                    .catch((error) => {
                        if (error.userRejected) {
                            // form.groupedBy = _.get(this._model._plan, "groupedBy", "detectedSku");
                            let updatedPristineValueStatus = this._updatePristineValueStatus(form);
                            this._formsComponent.setPristineValue(updatedPristineValueStatus);
                            return Promise.resolve();
                        } else {
                            console.warn(error);
                        }
                    });
            } else {
                this._onFormChangeValue();
            }

            this._toggleActions();
        }
    }

    _onFormChangeValue() {
        if (!_.isEmpty(this._model)) {
            const form = this._formsComponent.getValue();

            if (!this._renderingForm) {
                const formName = form.name;
                this._model._plan.setName(formName);
                this._model._plan.setDescription(form.description);
            }
        }
        return Promise.resolve();
    }

    _getSnapshotString(input) {
        const sortArray = ["PRE", "POST", "DEF"],
            result = [];

        sortArray.forEach((key) => {
            let found = false;
            input = input.filter((item) => {
                if (!found && item === key) {
                    result.push(item);
                    found = true;
                    return false;
                } else {
                    return true;
                }
            });
        });

        return result.length > 0 ? result.join("_") : "NONE";
    }

    _onPlanPropertiesChanged(pristineProperties, before) {
        if (!this._model) {
            return;
        }

        if (_.includes(disabledStatus, pristineProperties.status)) {
            this._rootElem.classList.add("disabled-form");
        } else {
            this._rootElem.classList.remove("disabled-form");
        }

        this._setFlowGraphicStatus(pristineProperties.status);
        // this._setFlowGraphicStatus(pristineProperties.status);
        // Toggling the button on all prop changes, though redundant reduces risk
        // this._showHideRemoveInvalidDevicesAction(pristineProperties.status);
        if (_.get(pristineProperties, "status", null) !== _.get(before, "status", null)) {
            // STATUS CHANGE
            this._enableDisableActionsBasedOnStatus(
                pristineProperties.status,
                this._model.isDirty()
            );
        }

        if (!this._renderingForm) {
            let formVal = this._formsComponent.getValue(); // Data from Jtype form
            let pristinePropsVal = this._getPristineValue(); // Data from _pristineProperties i.e. sync'd with BE
            let isDirty = this.model.isDirty();

            let updateReadOnlyFields = () => {
                _.keys(pristinePropsVal).map((id) => {
                    if (readOnlyFieldIds.indexOf(id) === -1) {
                        pristinePropsVal[id] = formVal[id];
                    } else {
                        this._model._plan.setProperty(id, pristinePropsVal[id]);
                    }
                });
                let updatedPristineValueStatus = this._updatePristineValueStatus(pristinePropsVal);
                this._formsComponent.setPristineValue(updatedPristineValueStatus);
                // this._renderGridRow();
                return Promise.resolve();
            };

            if (isDirty) {
                let isReadOnlyUpdate = true;
                _.keys(pristineProperties).map((id) => {
                    if (
                        readOnlyFieldIds.indexOf(id) === -1 &&
                        !_.isEqual(
                            _.isEmpty(pristineProperties[id]) ? "" : pristineProperties[id],
                            _.isEmpty(before[id]) ? "" : before[id]
                        )
                    ) {
                        isReadOnlyUpdate = false;
                    }
                });
                if (!isReadOnlyUpdate) {
                    this._model.gameEditor.runQuickConfirmationActionWorkflow(
                        {
                            message:
                                "This plan has been updated by another user. Do you want to refresh its details? All changes will be lost.",
                            title: "Update Confirmation Check",
                            confirmDetails: {
                                text: "Yes",
                                type: "text",
                            },
                        },
                        (this._onPlanDetailsRefreshAction =
                            this._onPlanDetailsRefreshAction.bind(this)),
                        updateReadOnlyFields
                    );
                } else {
                    updateReadOnlyFields();
                }
            } else {
                let updatedPristineValueStatus = this._updatePristineValueStatus(pristinePropsVal);
                this._formsComponent.setPristineValue(updatedPristineValueStatus);
                // this._renderGridRow();
                return Promise.resolve();
            }
        }
    }

    _enableDisableActionsBasedOnStatus(status, isDirty) {
        if (status === "") {
            status = this._model._plan.getStatus();
        }
        this._showHideValidationLogsAction();
        switch (status) {
            case "DRAFT":
            case "INVALID":
                if (isDirty) {
                    this.model.gameEditor.enableViewAction("SavePlanDetails");
                    this.model.gameEditor.enableViewAction("CancelPlanDetails");
                } else {
                    this.model.gameEditor.disableViewAction("SavePlanDetails");
                    this.model.gameEditor.disableViewAction("CancelPlanDetails");
                }

                this.model.gameEditor.enableViewAction("ManageDevices");
                this.model.gameEditor.enableViewAction("OsmOptions");

                // Validation Buttons
                this.model.gameEditor.enableViewAction("ValidatePlan");
                // this.model.gameEditor.enableViewAction("ValidationLogs");

                this.model.gameEditor.disableViewAction("DownloadUpgradeZip");
                this.model.gameEditor.disableViewAction("ImportUpgradeResults");
                break;
            case "VALIDATING":
            case "BUNDLING":
            case "UPLOADING_RESULTS":
            case "UPGRADE_COMPLETE":
                this._disableAllViewActions();
                break;
            case "VALIDATED":
                this.model.gameEditor.enableViewAction("ManageDevices");
                this.model.gameEditor.enableViewAction("OsmOptions");

                // Validation Buttons
                this.model.gameEditor.disableViewAction("ValidatePlan");
                // this.model.gameEditor.disableViewAction("ValidationLogs");

                this.model.gameEditor.enableViewAction("DownloadUpgradeZip");
                this.model.gameEditor.disableViewAction("ImportUpgradeResults");
                break;
            case "BUNDLE_ERROR":
                this.model.gameEditor.enableViewAction("ManageDevices");
                this.model.gameEditor.enableViewAction("OsmOptions");

                // Validation Buttons
                this.model.gameEditor.disableViewAction("ValidatePlan");
                // this.model.gameEditor.disableViewAction("ValidationLogs");

                this.model.gameEditor.enableViewAction("DownloadUpgradeZip");
                this.model.gameEditor.disableViewAction("ImportUpgradeResults");
                break;
            case "BUNDLED":
                this.model.gameEditor.disableViewAction("ManageDevices");
                this.model.gameEditor.disableViewAction("OsmOptions");

                // Validation Buttons
                this.model.gameEditor.disableViewAction("ValidatePlan");
                // this.model.gameEditor.disableViewAction("ValidationLogs");

                this.model.gameEditor.enableViewAction("DownloadUpgradeZip");
                this.model.gameEditor.enableViewAction("ImportUpgradeResults");
                break;
            case "UPGRADE_INCOMPLETE":
            case "UPGRADE_ERROR":
                this.model.gameEditor.disableViewAction("ManageDevices");
                this.model.gameEditor.disableViewAction("OsmOptions");

                // Validation Buttons
                this.model.gameEditor.disableViewAction("ValidatePlan");
                // this.model.gameEditor.disableViewAction("ValidationLogs");

                this.model.gameEditor.disableViewAction("DownloadUpgradeZip");
                this.model.gameEditor.enableViewAction("ImportUpgradeResults");
                break;
        }
    }

    _setFlowGraphicStatus(status) {
        // if (status !== "DRAFT" && status === this._previousStatus) {
        //     return;
        // }
        this._previousStatus = status;
        switch (status) {
            case "DRAFT":
                if (!this._model.isDirty()) {
                    const pristineProps = this._model._plan.getPristineProperties();
                    if (pristineProps.status !== "DRAFT") {
                        this._setInitialFlowGraphicStatus(pristineProps.status);
                    } else {
                        this.flowGraphic.setState("Draft", "saved");
                        this.flowGraphic.setState("Validate", "default");
                        this.flowGraphic.setState("Bundle", "default");
                        this.flowGraphic.setState("Upgrade", "default");
                    }
                } else {
                    this.flowGraphic.resetAll();
                }
                break;
            case "VALIDATION_ERROR":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "error");
                this.flowGraphic.setState("Bundle", "default");
                this.flowGraphic.setState("Upgrade", "default");
                break;
            case "VALIDATION_CANCELED":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "canceled");
                this.flowGraphic.setState("Bundle", "default");
                this.flowGraphic.setState("Upgrade", "default");
                break;
            case "INVALID":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "error");
                this.flowGraphic.setState("Bundle", "default");
                this.flowGraphic.setState("Upgrade", "default");
                break;
            case "VALIDATING":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "validating");
                this.flowGraphic.setState("Bundle", "default");
                this.flowGraphic.setState("Upgrade", "default");
                break;
            case "QUEUED":
            case "VALIDATED":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "validated");
                this.flowGraphic.setState("Bundle", "default");
                this.flowGraphic.setState("Upgrade", "default");
                break;
            case "BUNDLING":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "validated");
                this.flowGraphic.setState("Bundle", "bundling");
                this.flowGraphic.setState("Upgrade", "default");
                break;
            case "BUNDLED":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "validated");
                this.flowGraphic.setState("Bundle", "bundled");
                this.flowGraphic.setState("Upgrade", "default");
                break;
            case "BUNDLE_ERROR":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "validated");
                this.flowGraphic.setState("Bundle", "bundle_error");
                this.flowGraphic.setState("Upgrade", "default");
                break;
            case "UPLOADING_RESULTS":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "validated");
                this.flowGraphic.setState("Bundle", "bundled");
                this.flowGraphic.setState("Upgrade", "uploading_results");
                break;
            case "UPGRADE_COMPLETE":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "validated");
                this.flowGraphic.setState("Bundle", "bundled");
                this.flowGraphic.setState("Upgrade", "update_complete");
                break;
            case "UPGRADE_INCOMPLETE":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "validated");
                this.flowGraphic.setState("Bundle", "bundled");
                this.flowGraphic.setState("Upgrade", "update_incomplete");
                break;
            case "UPGRADE_ERROR":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "validated");
                this.flowGraphic.setState("Bundle", "bundled");
                this.flowGraphic.setState("Upgrade", "update_error");
                break;
        }
    }

    _setInitialFlowGraphicStatus(status) {
        this.flowGraphic.setState("Draft", "saved");
        if (status === "DRAFT") {
            return;
        }
        switch (status) {
            case "VALIDATION_ERROR":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "error");
                this.flowGraphic.setState("Bundle", "default");
                this.flowGraphic.setState("Upgrade", "default");
                break;
            case "VALIDATION_CANCELED":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "canceled");
                this.flowGraphic.setState("Bundle", "default");
                this.flowGraphic.setState("Upgrade", "default");
                break;
            case "INVALID":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "error");
                this.flowGraphic.setState("Bundle", "default");
                this.flowGraphic.setState("Upgrade", "default");
                break;
            case "VALIDATING":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "validating");
                this.flowGraphic.setState("Bundle", "default");
                this.flowGraphic.setState("Upgrade", "default");
                break;
            case "QUEUED":
            case "VALIDATED":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "validated");
                this.flowGraphic.setState("Bundle", "default");
                this.flowGraphic.setState("Upgrade", "default");
                break;
            case "BUNDLING":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "validated");
                this.flowGraphic.setState("Bundle", "bundling");
                this.flowGraphic.setState("Upgrade", "default");
                break;
            case "BUNDLED":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "validated");
                this.flowGraphic.setState("Bundle", "bundled");
                this.flowGraphic.setState("Upgrade", "default");
                break;
            case "BUNDLE_ERROR":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "validated");
                this.flowGraphic.setState("Bundle", "bundle_error");
                this.flowGraphic.setState("Upgrade", "default");
                break;
            case "UPLOADING_RESULTS":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "validated");
                this.flowGraphic.setState("Bundle", "bundled");
                this.flowGraphic.setState("Upgrade", "uploading_results");
                break;
            case "UPGRADE_COMPLETE":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "validated");
                this.flowGraphic.setState("Bundle", "bundled");
                this.flowGraphic.setState("Upgrade", "update_complete");
                break;
            case "UPGRADE_INCOMPLETE":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "validated");
                this.flowGraphic.setState("Bundle", "bundled");
                this.flowGraphic.setState("Upgrade", "update_incomplete");
                break;
            case "UPGRADE_ERROR":
                this.flowGraphic.setState("Draft", "saved");
                this.flowGraphic.setState("Validate", "validated");
                this.flowGraphic.setState("Bundle", "bundled");
                this.flowGraphic.setState("Upgrade", "update_error");
                break;
        }
    }

    _onFeedRefreshView() {
        let totalEntities = _.get(this._model._pagingRelatedFeed, "totalEntities", 0);
        let groupingValueLength = []; //_.get(this._groupingValuesFeed, "_valuesList", []);
        this._showGridMessage(totalEntities, groupingValueLength);
    }

    _onRefreshPlanDetails() {
        this._onPlanDetailsRefreshAction();
    }

    _onFeedDeviceRefreshView() {
        if (!this._model) {
            return;
        }
        let totalEntities = _.get(this._model._pagingRelatedFeed, "totalEntities", 0);
        let groupingValueLength = []; //_.get(this._groupingValuesFeed, "_valuesList", []);
        if (totalEntities === 0 && groupingValueLength.length === 0) {
            this._showDefaultMessageDisplay();
        }
    }

    _onGridUserSelectedRows(selectedRows) {
        // Update the active view with selected rows for status update action
        if (this._model && this._model._gameEditor && this._model._gameEditor._activeView) {
            this._model._gameEditor._activeView._selectedLinkForStatusUpdate = selectedRows;
        }
    }

    _onGridUserSorted(sortData) {
        this._model.onUserSorted(sortData);
    }

    _onGroupValuesChanged() {
        let totalEntities = _.get(
            this._model && this._model._pagingRelatedFeed,
            "_pagingRelatedFeed",
            0
        );
        let groupingValueLength = _.get(this._groupingValuesFeed, "_valuesList", []);
        this._showGridMessage(totalEntities, groupingValueLength);
    }

    _showGridMessage(totalFeed, totalGroupFeed) {
        if (totalFeed === 0 && totalGroupFeed.length === 0) {
            this._showDefaultMessageDisplay();
        } else {
            this._hideDefaultMessageDisplay();
        }
    }

    _showDefaultMessageDisplay() {
        if (this._gridSection) {
            const totalEntities = _.get(this._model, "_pagingDeviceFeed.totalEntities", 0);
            if (totalEntities !== 0) {
                this._emptyMessage.remove();
                this._gridSection.appendChild(this._emptyMessage);
            } else {
                this._emptyDeviceContainer.remove();
                this._gridSection.appendChild(this._emptyDeviceContainer);
            }
        }
    }

    _hideDefaultMessageDisplay() {
        this._emptyMessage.remove();
    }

    _onDirty(dirtyState) {
        this._isDirty = dirtyState;
        this._toggleActions();
        this._setFlowGraphicStatus(this._model._plan.getStatus());
    }

    _onPlanDetailsSave() {
        this._disableViewActions();
        return this._model
            .savePlan()
            .then(() => {
                this._disableViewActions();
            })
            .catch((/*err*/) => {
                this._enableViewActions();
            });
    }

    _onOsmOptionsClick() {
        this._onManageImages();
    }

    _onPlanDetailsCancel() {
        this.model.gameEditor.runQuickConfirmationActionWorkflow(
            {
                message: "Are you sure you want to cancel? All changes will be lost.",
                title: "Cancel Confirmation Check",
                confirmDetails: {
                    text: "Yes",
                    type: "text",
                },
            },
            (this._onPlanDetailsRefreshAction = this._onPlanDetailsRefreshAction.bind(this))
        );
    }

    _onPlanDetailsRefreshAction() {
        this.model.resetPlanProperties();
        this._refreshGrid();
        this._model._gameEditor.clearViewActions();
        return this.render();
    }

    _onPlanCancelsActions() {
        this._showViewActions();
    }

    _onAddDevices() {
        this._onManageDevices();
    }

    _onManageDevices() {
        let manageDevice = new manageDeviceComponent(this._model);
        let whenLoaderShown = this._model._modalUserFeedback.displayLoading({
            message: "Loading devices...",
        });
        return manageDevice.renderer
            .render()
            .then(() => {
                this._childViewRenderer = new childViewComponent({
                    data: manageDevice.renderer.rootElement,
                    backLink: "Details",
                    title: "Manage Devices",
                    childData: manageDevice,
                    parentData: this._model,
                    backButton: true,
                });
            })
            .then(() => whenLoaderShown)
            .then(() => this._model._modalUserFeedback.hideDisplayed())
            .catch((err) => {
                this._model.childViewOpen = undefined;
                this._logger.warn(
                    {error: err},
                    "IotOsPlanDetailsViewRenderer._onManageDevices() error."
                );
                // The child registered its toolbar actions and started its feeds before
                // failing: tear it down, then report the original error.
                return manageDevice
                    .shutdown()
                    .catch((teardownErr) => {
                        this._logger.warn(
                            {error: teardownErr},
                            "IotOsPlanDetailsViewRenderer._onManageDevices() teardown error."
                        );
                    })
                    .then(() => whenLoaderShown)
                    .then(() => this._model._modalUserFeedback.displayError(err));
            });
    }

    _onManageImages() {
        let manageImages = new manageImagesComponent(this._model);
        manageImages.renderer.render().then(() => {
            this._childViewRenderer = new childViewComponent({
                data: manageImages.renderer.rootElement,
                backLink: "Details",
                title: "Manage Images",
                childData: manageImages,
                parentData: this._model,
                backButton: true,
            });
        });
    }

    _onAddImages() {
        this._model._gameEditor.runAction(Registrations.ODM_OS_PLATFORM_EDITOR_ACTIONS_ADD_IMAGES);
    }

    _onValidatePlan() {
        this._validateView = new validateViewComponent(this._model);

        const validatePromise = [
            this._model._plan.isDirty() ? this._model.savePlan() : Promise.resolve(),
        ];

        Promise.all(validatePromise)
            .then(() => {
                //this._setViewActionText("ValidatePlan", "Validating...");
                this._model._gameEditor.hideViewAction("ValidatePlan");
                this._model._gameEditor.showViewAction("ValidationLogs");
                return this._validateView.renderer.render();
            })
            .then(() => {
                this._setViewActionText("ValidateViewPlan", "Validating...");
                this._validateView._renderer._disableDownload();
                this._validateView._renderer._disableValidatePlan();
                this._childViewRenderer = new childViewComponent({
                    data: this._validateView.renderer.rootElement,
                    backLink: "Details",
                    title: "OS Plan Validation",
                    childData: this._validateView,
                    parentData: this._model,
                    backButton: true,
                });
            })
            .catch((err) => {
                this._logger.warn(
                    {error: err},
                    "OsPlanDetailsViewRenderer._onValidatePlan() error."
                );
            });
    }

    _onSchedulePlan() {
        return this._checkDirty()
            .then(() => {
                return this._onPlanScheduleUserAction();
            })
            .catch((err) => {
                if (err.userRejected) {
                    return Promise.resolve(this._renderPlanDetails())
                        .then(() => this._renderGrid())
                        .then(() => {
                            this._isDirty = false;
                            return this._model._gameEditor.getTabCmpnt().setDirty(false);
                        })
                        .then(() => this._model._modalUserFeedback.hideDisplayed())
                        .then(() => this._onPlanScheduleUserAction());
                } else {
                    console.error("Error in _onSchedulePlan()! Err:", err);
                }
            });
    }

    _checkDirty() {
        if (this._isDirty) {
            return this._model._modalUserFeedback
                .displayConfirmation("Would you like to Save or Discard your changes?", {
                    title: "Unsaved Changes",
                    confirmDetails: {
                        text: "Save",
                        type: "additive",
                    },
                    rejectDetails: {
                        text: "Discard",
                        type: "text",
                    },
                })
                .then(() => {
                    return this._onPlanDetailsSave();
                })
                .catch(() => {
                    return Promise.resolve();
                });
        } else {
            return Promise.resolve();
        }
    }

    _onPlanScheduleUserAction() {
        let promAll = this._discardPlanChanges();
        return Promise.all(promAll)
            .then(() => {
                return this._model._modalUserFeedback.displayCustom(
                    new ScheduleComponent(this._model),
                    {dontHide: false}
                );
            })
            .then((/*result*/) => {
                this._onPlanCancelsActions("SCHEDULED");
                return this._refreshGrid();
            })
            .then(() => {
                this._renderPlanDetails();
                return this._renderGrid();
            })
            .then(() => {
                this._model._modalUserFeedback.hideDisplayed();
            })
            .catch((err) => {
                if (err && err.userRejected) {
                    this._logger.warn(
                        {error: err},
                        "OsPlanDetailsViewRenderer._onSchedulePlan() - User Canceled"
                    );
                    return;
                } else {
                    this._logger.warn(
                        {error: err},
                        "OsPlanDetailsViewRenderer._onSchedulePlan() - Error"
                    );
                    return this._model._modalUserFeedback.displayError(err);
                }
            });
    }

    _discardPlanChanges() {
        if (this._isDirty) {
            return [
                this.model.resetPlanProperties(),
                this._refreshGrid(),
                this._model._gameEditor.clearViewActions(),
                this.render(),
            ];
        } else {
            return [];
        }
    }

    _onRunNowPlan() {
        return this._checkDirty()
            .then(() => {
                return this._onRunNow();
            })
            .catch((err) => {
                if (err.userRejected) {
                    return Promise.resolve(this._renderPlanDetails())
                        .then(() => this._renderGrid())
                        .then(() => {
                            this._isDirty = false;
                            return this._model._gameEditor.getTabCmpnt().setDirty(false);
                        })
                        .then(() => this._model._modalUserFeedback.hideDisplayed());
                } else {
                    console.error("Error in _onSchedulePlan()! Err:", err);
                }
            });
    }

    _onRunNow() {
        let promAll = this._discardPlanChanges();
        return Promise.all(promAll)
            .then(() => {
                return this._model._modalUserFeedback.displayCustom(
                    new RunNowComponent(this._model),
                    {dontHide: false}
                );
            })
            .catch((err) => {
                if (err && err.userRejected) {
                    this._logger.warn(
                        {error: err},
                        "OsPlanDetailsViewRenderer._onRunNow() - User Canceled"
                    );
                    return;
                } else {
                    this._logger.warn(
                        {error: err},
                        "OsPlanDetailsViewRenderer._onRunNow() - Error"
                    );
                    return this._model._modalUserFeedback.displayError(err);
                }
            });
    }

    _onCancelSchedulePlan() {
        return this._model._gameEditor.runQuickConfirmationActionWorkflow(
            {
                message: "Are you sure you want to cancel the scheduled run?",
                title: "Cancel Schedule",
                confirmDetails: {
                    text: "Confirm",
                    type: "destructive",
                },
                rejectDetails: {
                    text: "Cancel",
                    type: "text",
                },
            },
            () => {
                return this._model
                    ._cancelScheduler()
                    .then((/*workResults*/) => {
                        this._enableDisableRunNowAction();
                        this._enableAllActions();
                        this._toggleActions();
                        this.model.gameEditor.hideViewAction("CancelSchedulePlan");
                        this.model.gameEditor.showViewAction("SchedulePlan");
                        return this._refreshGrid();
                    })
                    .then(() => {
                        this._renderPlanDetails();
                        this._renderGrid();
                    })
                    .catch((err) => {
                        if (err && err.userRejected) {
                            this._logger.warn(
                                {error: err},
                                "OsPlanDetailsViewRenderer._onCancelSchedulePlan() - User Canceled"
                            );
                            return;
                        } else {
                            this._logger.warn(
                                {error: err},
                                "OsPlanDetailsViewRenderer._onCancelSchedulePlan() - Error"
                            );
                            if (this._model._plan.status !== "SCHEDULED") {
                                this._enableDisableRunNowAction();
                                this._enableAllActions();
                                this._toggleActions();
                                this.model.gameEditor.hideViewAction("CancelSchedulePlan");
                                this.model.gameEditor.showViewAction("SchedulePlan");
                                this._refreshGrid().then(() => {
                                    this._renderPlanDetails();
                                    this._renderGrid();
                                });
                            }

                            return this._model._modalUserFeedback.displayError(err);
                        }
                    });
            }
        );
    }

    _onViewValidationLogs() {
        this._model._modalUserFeedback.displayLoading();
        let validateViewRenderer;
        if (!this._validateView) {
            this._validateView = new validateViewComponent(this._model);
            validateViewRenderer = this._validateView._renderer;
        }
        this._validateView._workId =
            this.model._plan.getPristineProperties().lastWorkId || this._model._validateWorkId;
        this._validateView._getValidationLogs(this._validateView._workId).then(() => {
            this._childViewRenderer = new childViewComponent({
                data: this._validateView.renderer.rootElement,
                backLink: "Details",
                title: "OS Plan Validation",
                childData: this._validateView,
                parentData: this._model,
                backButton: true,
            });
            validateViewRenderer._registerViewActions();
        });
    }

    _onResetPlan() {
        //Todo: reset plan to draft
        return this._model._modalUserFeedback
            .displayConfirmation("The status of the plan will be reset to DRAFT.", {
                title: "Reset OS Plan Status",
                confirmDetails: {
                    text: "OK",
                    type: "text",
                },
                rejectDetails: {
                    text: "Cancel",
                    type: "text",
                },
            })
            .then(() => {
                this._model._plan.setStatus("DRAFT");
                return this._onPlanDetailsSave();
            })
            .then(() => {
                this._model._planCanBeReset = false;
                return this._onPlanDetailsRefreshAction();
            })
            .catch((err) => {
                this._logger.warn({error: err}, "OS Plan::Plan reset failed");
                return Promise.resolve();
            });
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _getPristineValue() {
        let pristineProperties = this._model._plan.getPristineProperties();
        let pristineValue = {};

        if (pristineProperties) {
            pristineValue.name = pristineProperties.name;
            pristineValue.description = pristineProperties.description;
            pristineValue.status = _.get(
                this._model._plan.getStatusLabels(),
                pristineProperties.status,
                "DRAFT"
            );
            pristineValue.ignoreLinkIds = pristineProperties.ignoreLinkIds || [];
        }
        return pristineValue;
    }

    _getJtype() {
        let jtype = {};

        jtype.name = "";
        jtype["name@Display.label"] = "Name";

        jtype.graphic = ""; // Placeholder for flow graphic display
        jtype["graphic@Display.label"] = "Progress";

        jtype.description = "";
        jtype["description@Display.label"] = "Description";

        jtype.status = "";
        jtype["status@Display.label"] = "Status";
        jtype["status@Display.readOnly"] = true;

        return jtype;
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = OsPlanDetailsViewRenderer;
